export default {
  title: 'SIDEN, DU LEDER EFTER, MÅ VÆRE HER ET STED...',
  description: 'Leder du efter en af siderne nedenfor?',
  not_found: 'Vi kan ikke finde den url, du indtastede. Tjek, om den er skrevet korrekt.',
  no_restaurants: {
    title: 'Denne butik har endnu ikke åbnet for onlinebestillinger',
    description: 'Kom snart tilbage.',
  },
  toasts: {
    failed_to_load_stores: 'Butikkerne kunne ikke indlæses. Opdater siden',
  },
};
